import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.metaGroupI18ns">
                <label class="label">{{ 'metaField.Meta group name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.metaGroupI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    `
})
export default class {
    constructor (FORMS_POOL_ENUM, TokenService, QuestionService) {
        this.QuestionService = QuestionService;
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/meta/group/generaldata/index.js